import React from 'react';

const StripePartner = () => {
  return (
    <svg
      width="auto"
      height="32"
      viewBox="0 0 272 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      alt="Verified Stripe partner"
    >
      <rect
        x="12.1386"
        y="0.846875"
        width="258.523"
        height="63.7979"
        rx="4.28271"
        fill="white"
        stroke="#C8D0D8"
        strokeWidth="1.69375"
      />
      <mask
        id="mask0_294_415"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="271"
        height="66"
      >
        <rect
          x="0.846875"
          y="0.846875"
          width="269.306"
          height="63.7979"
          rx="4.28271"
          fill="white"
          stroke="#C8D0D8"
          strokeWidth="1.69375"
        />
      </mask>
      <g mask="url(#mask0_294_415)">
        <rect
          x="-58.265"
          y="-86.4648"
          width="202.444"
          height="173.892"
          transform="rotate(12 -58.265 -86.4648)"
          fill="#635BFF"
        />
      </g>
      <path
        d="M146.452 35.9005H151.672C156.926 35.9005 160.209 33.3724 160.209 28.6774C160.209 23.9166 156.926 21.4542 151.672 21.4542H142.249V45.028H146.452V35.9005ZM146.452 32.289V25.0658H151.442C154.463 25.0658 156.072 26.3462 156.072 28.6774C156.072 30.9756 154.463 32.289 151.442 32.289H146.452Z"
        fill="#0A2540"
      />
      <path
        d="M175.766 40.8911V32.3546C175.766 29.2355 173.336 27.4625 169.298 27.4625C165.325 27.4625 162.305 29.2355 162.173 33.2083H166.015C166.113 31.698 167 30.8771 169.068 30.8771C170.841 30.8771 171.925 31.4353 171.925 32.9784V33.8321L167.164 34.8171C163.848 35.5066 161.385 36.9512 161.385 40.2345C161.385 43.3207 163.913 45.3235 167.197 45.3235C169.265 45.3235 170.973 44.7325 172.089 43.6491C172.089 44.1416 172.122 44.6012 172.187 45.028H176.029C175.832 43.7804 175.766 42.3029 175.766 40.8911ZM171.925 38.954C171.925 41.0553 169.889 42.1716 167.788 42.1716C166.277 42.1716 165.292 41.4164 165.292 40.0703C165.292 38.5272 166.54 38.0018 168.215 37.6407L171.925 36.8527V38.954Z"
        fill="#0A2540"
      />
      <path
        d="M188.747 27.758C188.452 27.7252 188.09 27.6924 187.631 27.6924C185.431 27.6924 183.658 28.743 182.903 30.3518V27.7909H178.963V45.028H182.903V35.9662C182.903 33.2083 184.807 31.5995 187.302 31.5995C187.861 31.5995 188.255 31.6323 188.747 31.698V27.758Z"
        fill="#0A2540"
      />
      <path
        d="M193.076 40.6941C193.076 44.2072 194.849 45.225 198.133 45.225C199.15 45.225 200.135 45.1265 200.858 44.9952V41.6791C200.267 41.7448 199.906 41.7776 199.249 41.7776C197.837 41.7776 196.951 41.6134 196.951 40.0703V31.1398H200.562V27.7909H196.951V22.7346H193.076V27.7909H190.68V31.1398H193.076V40.6941Z"
        fill="#0A2540"
      />
      <path
        d="M203.973 45.028H207.913V34.9156C207.913 32.4531 209.719 31.1398 211.492 31.1398C213.659 31.1398 214.513 32.6829 214.513 34.8171V45.028H218.452V33.6679C218.452 29.9578 216.285 27.4625 212.674 27.4625C210.441 27.4625 208.898 28.4804 207.913 29.6295V27.7909H203.973V45.028Z"
        fill="#0A2540"
      />
      <path
        d="M229.434 45.3892C232.882 45.3892 235.607 43.5834 236.822 40.5628L233.44 39.2823C232.914 41.0553 231.371 42.0403 229.434 42.0403C226.906 42.0403 225.133 40.2345 224.838 37.2795H236.92V35.9662C236.92 31.2383 234.261 27.4625 229.27 27.4625C224.476 27.4625 221.062 31.3696 221.062 36.4259C221.062 41.7448 224.509 45.3892 229.434 45.3892ZM229.237 30.7786C231.732 30.7786 232.914 32.4203 232.947 34.3246H225.035C225.626 31.9935 227.202 30.7786 229.237 30.7786Z"
        fill="#0A2540"
      />
      <path
        d="M249.89 27.758C249.595 27.7252 249.234 27.6924 248.774 27.6924C246.574 27.6924 244.801 28.743 244.046 30.3518V27.7909H240.106V45.028H244.046V35.9662C244.046 33.2083 245.95 31.5995 248.446 31.5995C249.004 31.5995 249.398 31.6323 249.89 31.698V27.758Z"
        fill="#0A2540"
      />
      <path
        d="M66.7663 16.3729V20.9828L60.9953 22.1549V17.5449L66.7663 16.3729ZM96.7135 28.4837C95.2317 28.4837 93.672 29.5776 93.672 32.2342H99.677C99.677 29.6558 98.1173 28.4837 96.7135 28.4837ZM77.5286 28.8744C76.2028 28.8744 75.4229 29.3432 74.799 30.0464V38.7193C75.3449 39.3444 76.1248 39.8132 77.5286 39.8132C79.6342 39.8132 81.038 37.4692 81.038 34.3438C81.038 31.2966 79.6342 28.8744 77.5286 28.8744ZM54.6783 25.6709C56.0041 23.1706 58.6556 23.6394 59.4355 23.952V29.3432C58.7336 29.1088 56.472 28.7181 55.1462 30.5934V44.5013H49.4531V23.952H54.3663L54.6783 25.6709ZM66.7663 24.0301V44.4231H60.9953V24.0301H66.7663ZM29.1763 23.6394C31.048 23.6394 32.9977 23.952 34.8694 24.7333V30.2808C33.1537 29.3432 30.8921 28.7963 29.1763 28.7963C28.0065 28.7963 27.2267 29.1869 27.2267 30.0464C27.2267 32.703 36.0393 31.4528 36.0393 38.4849C36.0393 42.7823 32.7638 45.2045 28.0065 45.2045C26.0568 45.2045 23.8732 44.8138 21.6896 43.8762V38.2505C23.6392 39.3444 26.0568 40.1257 28.0065 40.1257C29.2543 40.1257 30.1902 39.7351 30.1902 38.6412C30.1902 35.8284 21.4556 36.8441 21.4556 30.359C21.3776 26.2178 24.4971 23.6394 29.1763 23.6394ZM43.2141 19.0295V24.1082H47.5814V29.1869H43.2141V37.5473C43.2141 40.9852 46.8015 39.9695 47.5814 39.6569V44.4231C46.8015 44.8919 45.3978 45.2045 43.5261 45.2045C40.0946 45.2045 37.599 42.626 37.599 39.11V20.2015L43.2141 19.0295ZM96.7915 23.6394C102.329 23.6394 105.214 28.4056 105.214 34.5001C105.214 35.047 105.136 36.2972 105.136 36.6097H93.75C93.9839 39.3444 96.0116 40.2039 98.2732 40.2039C100.613 40.2039 102.407 39.7351 103.966 38.8756V43.6418C102.407 44.5013 100.301 45.2045 97.4934 45.2045C91.8003 45.2045 87.9009 41.6103 87.9009 34.4219C87.9009 28.4837 91.2544 23.6394 96.7915 23.6394ZM78.9323 23.6394C82.9877 23.6394 86.7311 27.3117 86.7311 34.1875C86.7311 41.6103 82.9877 44.9701 78.8544 44.9701C76.8267 44.9701 75.6569 44.1106 74.799 43.4855V50.1269L69.028 51.3771V24.0301H74.0971L74.4091 25.5146C75.189 24.7333 76.6707 23.6394 78.9323 23.6394Z"
        fill="white"
      />
    </svg>
  );
};

export default StripePartner;
